var searchSuggester = {
	inputPlaceholder: "Buscar",
	clearSearchTerm: "Borrar término de búsqueda",
	noResults: "No se encontraron resultados",
	allSearchResults: "Todos los resultados de búsqueda",
	validationErrors: {
		searchTerm: {
			invalidInput: "Entrada inválida"
		}
	}
};
var searchSuggesterTranslationsEs = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsEs as default, searchSuggester };
